import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { FavoritesProvider as ConsumerPortalFavoritesProvider } from '@seeker-consumer-portal/favorite-heart';
import { useBrandConfiguration } from '../../../brands/context';
import { useStageConfiguration } from '../../../hooks/useStageConfiguration';
export const FavoritesProvider = ({ children }) => {
    const { mfes: { favoriteHeartBrandId }, } = useBrandConfiguration();
    const { stage } = useStageConfiguration();
    if (!favoriteHeartBrandId)
        return _jsx(_Fragment, { children: children });
    return (_jsx(ConsumerPortalFavoritesProvider, { brand: favoriteHeartBrandId, env: stage, children: children }));
};
